import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

function isOnline(): boolean {
  return typeof navigator === 'undefined' || navigator.onLine !== false;
}

export function OfflineBanner() {
  const { t } = useTranslation('layout');
  const [online, setOnline] = useState(isOnline);

  useEffect(() => {
    function updateStatus() {
      setOnline(isOnline());
    }

    window.addEventListener('online', updateStatus);
    window.addEventListener('offline', updateStatus);
    return () => {
      window.removeEventListener('online', updateStatus);
      window.removeEventListener('offline', updateStatus);
    };
  }, []);

  return online ? null : (
    <div className="offline-banner" role="status" aria-live="polite">
      {t('offline.message')}
    </div>
  );
}
